import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsSaving, getLastSavedPpiId } from '../selectors';
import { savePpi as savePpiAction } from '../actions';

const useSavePpi = () => {
  const [hasSaved, setHasSaved] = useState(false);
  const dispatch = useDispatch();
  const isSaving = useSelector(getIsSaving);
  const savedPpiId = useSelector(getLastSavedPpiId);

  const savePpi = (id, ppi, callback) => {
    dispatch(savePpiAction(id, ppi, callback));
    setHasSaved(true);
  };

  return [savePpi, isSaving, hasSaved ? savedPpiId : null];
};

export default useSavePpi;
